import Bootstrap from './common/bootstrap.js'
import './app/lang/api'
Bootstrap.run()



// WEBPACK FOOTER //
// ./src/main.js